<div class="tab-box overflow-auto">
  <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2 " id="i-4"
    (click)="onCurrentTab('manage_visa')" [ngClass]="currentTab == 'manage_visa' ? 'active-tab' : ''">
    <div class="tab-txt ps-1 ps-sm-2">{{"EMPLOYEE.VISA.MANAGE" | translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
    (click)="onCurrentTab('documents')" [ngClass]="currentTab == 'documents' ? 'active-tab' : ''">
    <div class="tab-txt ps-1 ps-sm-2">{{"EMPLOYEE.DOCUMENT.DOCUMENTS" | translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
    (click)="onCurrentTab('manage_roles')" [ngClass]="currentTab == 'manage_roles' ? 'active-tab' : ''">
    <div class="tab-txt ps-1 ps-sm-2">{{"EMPLOYEE.JOBPREFERENCE.MANAGE" | translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
    (click)="onCurrentTab('manage_clocking')" [ngClass]="currentTab == 'manage_clocking' ? 'active-tab' : ''">
    <div class="tab-txt ps-1 ps-sm-2">{{"RECRUITER.EMPLOYEECLOCKING" | translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
    (click)="onCurrentTab('con_documents')" [ngClass]="currentTab == 'con_documents' ? 'active-tab' : ''">
    <div class="tab-txt ps-1 ps-sm-2">{{"Contract Document" | translate}}</div>
  </div>
</div>
<div class="mt-3">
  <div *ngIf="currentTab=='manage_visa'">
    <app-visa [employeeId]="employeeId"></app-visa>
  </div>

  <div class="d-flex flex-column">
    <div *ngIf="currentTab=='con_documents'" class="d-flex flex-column">
      <button mat-raised-button color="primary" *ngIf="currentTab=='con_documents'"
        class="primary-btn mt-1 mb-4 ms-auto" type="submit" (click)="onAddContract()">
        <i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} {{"DOCUMENT.CONTRACT"|translate}}
      </button>
      <div class="row-r gap-3" *ngIf="contractArr.length > 0">
        <div class="pack-box d-flex  contract-box" *ngFor="let item of contractArr">
          <div class="signed-c" *ngIf="item.signed_count > 0">{{"DOCUMENT.SIGNED"|translate}}</div>
          <div class="pack-img place-center cursor-pointer" (click)="onViewContractDoc(item)"> <img
              src="assets/images/icons/contract_file_ic.svg" class="img-fluid con-i" alt=""></div>
          <div class="d-flex pack-cont flex-grow-1">
            <div class="ps-2 p-left">
              <div class="d-flex pt-1 price">
                <span class="text-medium doc-item ps-1">{{ item.title }}</span>
              </div>
            </div>
            <i class="material-icons cursor-pointer more-icon" [matMenuTriggerFor]="menu">more_vert</i>
            <mat-menu #menu="matMenu">
              <button mat-menu-item color="primary" (click)="onViewSignedContract(item)">
                <mat-icon class="kt-margin-r-0">visibility</mat-icon>
                <span>{{'BUTTON.VIEW' | translate}} {{"DOCUMENT.SIGNED"|translate}}
                  {{"DOCUMENT.CONTRACT"|translate}}</span>
              </button>
              <button mat-menu-item color="primary" (click)="onFile(baseUrl,item.document)">
                <mat-icon class="kt-margin-r-0">file_download</mat-icon>
                <span>{{'BUTTON.DOWNLOAD' | translate}}</span>
              </button>
              <button mat-menu-item color="primary" (click)="onDeleteItem(item.document_id)">
                <img class="me-3" src="assets/images/icons/delete-icon.svg" alt="">
                <span>{{'BUTTON.DELETE' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div class="mat-table__message" *ngIf="contractArr.length == 0">
        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
      </div>
    </div>
  </div>

  <div class="d-flex flex-column gap-3 p-3">
    <div *ngIf="currentTab=='documents'" class="d-flex flex-column gap-2">
      <div class="title mt-0">
        Contract document
      </div>
      <div class="det-contaner d-flex" *ngFor="let item1 of empContractDoc">
        {{item1.title}}
        <img class="ms-auto cursor-pointer" *ngIf="item1.base_url && item1.doc_name"
          (click)="onFileAll(item1.base_url,item1.doc_name)" src="assets/images/icons/download_ic .svg" alt="">
        <!-- <button *ngIf="item1.base_url && item1.doc_name" color="warn" (click)="onFileAll(item1.base_url,item1.doc_name)" type="button">
            <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
          </button> -->
      </div>
      <div class="d-flex flex-grow-1 mt-lg-3" *ngIf="empContractDoc.length == 0">
        <div class="mat-table__message">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>

      <div class="title">
        Usefull document
      </div>
      <div class="det-contaner d-flex" *ngFor="let item3 of empUsefullDoc">
        {{item3.tit}}
        <img class="ms-auto cursor-pointer" *ngIf="item3.data" (click)="onFileDownloadAll(item3.data)"
          src="assets/images/icons/download_ic .svg" alt="">

        <!-- <button *ngIf="item3.data" color="warn" (click)="onFileDownloadAll(item3.data)" type="button">
          <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
        </button> -->
      </div>
      <div class="d-flex flex-grow-1 mt-lg-3" *ngIf="empUsefullDoc.length == 0">
        <div class="mat-table__message">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>

      <div class="title">
        Personal document
      </div>
      <div class="det-contaner d-flex " *ngFor="let item2 of empPersonalDoc">
        {{item2.d_n}}
        <img class="ms-auto cursor-pointer" *ngIf="item2.data" (click)="onFileDownloadAll(item2.data)"
          src="assets/images/icons/download_ic .svg" alt="">
        <!-- <button *ngIf="item2.data" color="warn" (click)="onFileDownloadAll(item2.data)" type="button">
          <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
        </button> -->
      </div>
      <div class="d-flex flex-grow-1 mt-lg-3" *ngIf="empPersonalDoc.length == 0">
        <div class="mat-table__message">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>

      <div class="title">
        Course document
      </div>
      <div class="emp-detail pt-4 pt-sm-0 px-sm-3 px-md-4" *ngIf="empCourseData">
        <h6 class="mb-3 " *ngIf="empCourseData.folder.length > 0">
          {{"DOCUMENT.FOLDERS"|translate}}
        </h6>
        <div class="d-flex flex-wrap" *ngIf="empCourseData.folder.length > 0">
          <div class="fol-cont" *ngFor="let item of empCourseData.folder">
            <div class="fol-b d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div (click)="onViewFolder(item.id, item.employee_id)">
                  <img src="assets/images/documents/folder.png" class="img-fluid" />
                </div>
                <div class="ps-2" (click)="onViewFolder(item.id, item.employee_id)">
                  <div class="f-h">{{ item.title }}</div>
                </div>
              </div>
              <i class="material-icons cursor-pointer" [matMenuTriggerFor]="menu2">more_vert</i>
              <mat-menu #menu2="matMenu" (click)="onFileDownload(item.document)">
                <button mat-menu-item color="warn" (click)="onDeleteCourseDocItem(item.id)" type="button">
                  <mat-icon class="kt-margin-r-0">delete</mat-icon>
                  <span>{{'BUTTON.DELETE' | translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <h6 class="mb-3  mt-2" *ngIf="empCourseData.files.length > 0"> {{"DOCUMENT.FILES"|translate}}</h6>
        <div class="d-flex flex-wrap" *ngIf="empCourseData.files.length > 0">
          <div class="file-b d-flex flex-column" *ngFor="let item of empCourseData.files">
            <div class="file-img flex-grow-1"></div>
            <div class="f-detail d-flex justify-content-between px-2">
              <div class="d-flex">
                <div class="f-img">
                  <img src="assets/images/documents/pdf.png" class="img-fluid" />
                </div>
                <div class="ps-2">
                  <div class="f-h">{{ item.title }}</div>
                </div>
              </div>
              <i class="material-icons cursor-pointer del-ic" [matMenuTriggerFor]="menu">more_vert</i>
              <mat-menu #menu="matMenu">
                <button mat-menu-item color="warn" (click)="onFileDownload(item.document)" type="button">
                  <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
                  <span>{{'BUTTON.DOWNLOAD' | translate}}</span>
                </button>
                <button mat-menu-item color="warn" (click)="onDeleteCourseDocItem(item.id)" type="button">
                  <mat-icon class="kt-margin-r-0">delete</mat-icon>
                  <span>{{'BUTTON.DELETE' | translate}}</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-grow-1 mt-lg-3" *ngIf="empCourseData?.files.length == 0 && empCourseData?.folder.length == 0">
        <div class="mat-table__message">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>


    </div>
  </div>


  <div *ngIf="currentTab=='manage_roles'">
    <app-job-preference-detail [employeeId]="employeeId"></app-job-preference-detail>
  </div>
  <div *ngIf="currentTab=='manage_clocking'">
    <app-manage-clocking [employeeId]="employeeId"> </app-manage-clocking>
  </div>
</div>